import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { TasksController } from '../controller/TasksController';

export class TasksWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TasksController,
    });
  }
}
